module.exports = __webpack_public_path__ + "static/media/journal.3329d639.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/journal.svg
// module id = 95
// module chunks = 0